import React from "react";
import { Trash2 } from "lucide-react";
import { RawAdmin } from "../../../utils/getAdmins";

interface AdminItemProps {
  admin: RawAdmin;
  districtName: string;
  onDelete: (admin: RawAdmin) => void;
}

export function AdminItem({ admin, districtName, onDelete }: AdminItemProps) {
  return (
    <tr key={admin.id}>
      <td className="px-6 py-4">
        <div className="text-sm font-medium text-gray-900">
          {admin.fullname}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">{admin.email}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {districtName || "Not assigned"}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {new Date(admin.created_at).toLocaleDateString()}
        </div>
      </td>
      <td className="px-6 py-4">
        <button
          onClick={() => onDelete(admin)}
          className="text-red-400 hover:text-red-600 transition-colors"
          title="Delete Admin"
        >
          <Trash2 className="h-5 w-5" />
        </button>
      </td>
    </tr>
  );
}
